import React from 'react';
import { Search } from 'lucide-react';

export const HeroSearchBar = ({ searchQuery, setSearchQuery, handleSearch }) => (
  <form onSubmit={handleSearch} className="relative" data-testid="hero-search-form">
    <div className="absolute -inset-1 bg-gradient-to-r from-gold-400/60 via-gold-500/40 to-gold-600/60 blur-lg rounded-2xl"></div>
    <div className="relative bg-white/95 backdrop-blur-md rounded-xl shadow-2xl border-2 border-gold-400/30 overflow-hidden">
      <div className="flex items-center">
        <div className="flex-1 flex items-center px-5 py-4">
          <Search className="w-6 h-6 text-[#143160] mr-3 flex-shrink-0" />
          <input
            data-testid="hero-search-input"
            type="text"
            placeholder="Search homes in Virginia & North Carolina..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-transparent text-gray-800 placeholder-gray-500 text-lg font-medium focus:outline-none"
          />
        </div>
        <button type="submit" className="m-2 px-8 py-3 bg-gradient-to-r from-[#143160] to-[#1E4A86] hover:from-[#1E4A86] hover:to-[#143160] text-white font-bold rounded-lg transition-all duration-300 hover:scale-105 shadow-lg flex items-center space-x-2">
          <Search className="w-5 h-5" />
          <span>Search</span>
        </button>
      </div>
    </div>
  </form>
);
